import { instance4, TYPE_INSTANCE2, TYPE_INSTANCE4 } from "App/constants"
import { makeStyles } from "@material-ui/core/styles"
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme"
import { useSelectOption } from "App/hooks"
import { isNull } from "App/utils/helpers"
import { LIST_URL_WAREHOUSE } from "utils/warehouse"

export const urlGet = LIST_URL_WAREHOUSE.masterBarangPBF.get
export const urlCreate = LIST_URL_WAREHOUSE.masterBarangPBF.add
export const urlUpdate = LIST_URL_WAREHOUSE.masterBarangPBF.update
export const urlUpdateHPP = LIST_URL_WAREHOUSE.masterBarangPBF.updateHPP
export const urlDelete = LIST_URL_WAREHOUSE.masterBarangPBF.delete
export const urlGetById = LIST_URL_WAREHOUSE.masterBarangPBF.getById
export const urlGetWithTarif = LIST_URL_WAREHOUSE.masterBarangPBF.getWithTarif

export const urlGetProdusen = LIST_URL_WAREHOUSE.masterProdusenPBF.get
export const urlGetKelasTerapi = LIST_URL_WAREHOUSE.masterKelasTerapiPBF.get
export const urlGetJenisObat = LIST_URL_WAREHOUSE.masterJenisObatPBF.get
export const urlGetGolonganObat = LIST_URL_WAREHOUSE.masterGolonganObatPBF.get
export const urlGetFormula = LIST_URL_WAREHOUSE.masterFormula.get

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  nama: "",
  status: 2,

  produsen_id: null,
  produsen_name: "Pilih Produsen",

  jenisharga_id: null,
  jenisharga_name: "Pilih Jenis Harga",
}
export const RESET_STATE_MASTER_BARANG = {
  name: "",
  satuanbeli_id: null,
  satuanbeli_name: "Piih Satuan Beli",

  satuanjual_id: null,
  satuanjual_name: "Pilih Satuan Jual",

  qjb: "0",
  kode_produk: "",
  komposisi: "",

  kelasterapi_id: null,
  kelasterapi_name: "Pilih Kelas Terapi",

  golongan_id: "",

  produsen_id: null,
  produsen_name: "Pilih Produsen",

  jenisobat_id: "",
  is_formularium: 1,

  formula_id: null,
  formula_name: "Pilih Formula",

  stockmin: 0,
  stockmax: 0,
  nilaikritis: 0,
  insurance_id: 1,
  golcoa_id: 1,
  isformula: 1,

  barcode: "",
  is_active: true,
  status: true,

  id_tarif_cbg: null,
  tarif_cbg: "Pilih Tarif CBG",

  // tidak diinput user
  // harga_pokok: 0,
  persediaan: "0",
  qty: "0",

  hargabeliAwal: 0,
  hargabeli: 0,
  hargabeli2: 0,

  harga_pokokAwal: 0,
  harga_pokok: 0,
  harga_pokok2: 0,

  kode_kfa_pa: "",
  kode_kfa_pv: "",
  kode_name: "",
  kode_kfa_pv_label: "Pilih Kode KFA",
  bahan_baku_zat_aktif_kode_kfa_pa: "",
  bahan_baku_numerator: "",
  bentuk_sediaan_kode: "",
}

export const STYLE_MASTER_BARANG = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
})

export const validation = (formData) => {
  if (isNull(formData.stockmin) || formData.stockmin < 0) {
    return {
      state: false,
      message: "stock min tidak boleh kurang dari 0 atau kosong!",
    }
  }

  if (isNull(formData.stockmax) || formData.stockmax < 0) {
    return {
      state: false,
      message: "stock max tidak boleh kurang dari 0 atau kosong!",
    }
  }

  if (isNull(formData.nilaikritis) || formData.nilaikritis < 0) {
    return {
      state: false,
      message: "nilai kritis tidak boleh kurang dari 0 atau kosong!",
    }
  }

  if (isNull(formData.kelasterapi_id)) {
    return {
      state: false,
      message: "Kelas terapi tidak boleh kosong!",
    }
  }

  if (isNull(formData.formula_id)) {
    return {
      state: false,
      message: "Formula tidak boleh kosong!",
    }
  }

  if (isNull(formData.satuanbeli_id)) {
    return {
      state: false,
      message: "Satuan beli tidak boleh kosong!",
    }
  }

  if (isNull(formData.satuanjual_id)) {
    return {
      state: false,
      message: "Satuan jual tidak boleh kosong!",
    }
  }

  return {
    state: true,
  }
}

export const getByFilterBarangExport = async (formFilter) => {
  try {
    const api = await instance4.post(
      LIST_URL_WAREHOUSE.masterBarangPBF.getWithTarifExport,
      {
        // halaman: pages,
        // jumlah: limit,
        id: formFilter.id,
        nama: formFilter.nama,
        produsen_id: formFilter.produsen_id,
        id_jenis_harga: formFilter.jenisharga_id,
      },
    )

    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        // meta: {
        //   count: parseInt(res.count),
        //   pages: parseInt(res.halaman),
        //   limit: parseInt(res.jumlah),
        // },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getByFilterBarang = async (
  formFilter,
  pages,
  limit,
  url = urlGet,
) => {
  try {
    const api = await instance4.post(url, {
      halaman: pages,
      jumlah: limit,
      id: formFilter.id,
      nama: formFilter.nama,
      produsen_id: formFilter.produsen_id,
      id_jenis_harga: formFilter.jenisharga_id,
      status: parseInt(formFilter.status),
    })

    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getById = async (id) => {
  try {
    const res = await instance4.get(`${urlGetById}/${id}`)
    // const res = await test_warehouss.get(`${urlGetById}/${id}`);
    // console.log("res", res);
    if (res.data.status === 200) {
      return {
        state: true,
        data: res.data.data,
      }
    } else {
      return {
        state: false,
        message: "Sepertinya ada yang tidak beres dg data ini",
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const deleteMasterBarangById = async (id) => {
  try {
    await instance4.post(urlDelete, {
      id,
    })
    return {
      state: true,
      message: "Berhasil menghapus data",
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}
export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "kode_kfa",
    disablePadding: false,
    label: "KODE KFA",
    align: "left",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "qty_total",
    disablePadding: false,
    label: "QTY",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "satuan_beli",
    disablePadding: false,
    label: "SATUAN BELI",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "satuan_jual",
    disablePadding: false,
    label: "SATUAN JUAL",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "stockmin",
    disablePadding: false,
    label: "STOK MIN",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "stockmax",
    disablePadding: false,
    label: "STOK MAX",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "hargapokok",
    disablePadding: false,
    label: "HPP",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "hargabeli",
    disablePadding: false,
    label: "HARGA BELI",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "qty_total",
    disablePadding: false,
    label: "PERSEDIAAN",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "qjb",
    disablePadding: false,
    label: "QJB",
    align: "left",
  },
  {
    id: "namaProdusen",
    disablePadding: false,
    label: "PRODUSEN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nama_golongan_harga",
    disablePadding: false,
    label: "JENIS HARGA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nama_kelas_terapi",
    disablePadding: false,
    label: "KELAS TERAPI",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nama_golongan",
    disablePadding: false,
    label: "GOLONGAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nama_jenis_obat",
    disablePadding: false,
    label: "JENIS OBAT",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nama_formula",
    disablePadding: false,
    label: "FORMULA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
    minWidth: "200px",
  },
  // {
  //   id: "createdAt",
  //   disablePadding: false,
  //   label: "INSERTED TIME",
  //   sort: false,
  //   minWidth: "170px",
  // },
  // {
  //   id: "createdBy",
  //   disablePadding: false,
  //   label: "INSERTED BY",
  //   sort: false,
  //   minWidth: "150px",
  // },
  // {
  //   id: "updatedAt",
  //   disablePadding: false,
  //   label: "UPDATED TIME",
  //   sort: false,
  //   minWidth: "170px",
  // },
  // {
  //   id: "updatedBy",
  //   disablePadding: false,
  //   label: "UPDATED BY",
  //   sort: false,
  //   minWidth: "150px",
  // },
]

export const headCellsWithoutTarif = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    sort: false,
    minWidth: "200px",
  },
  {
    id: "satuan_beli",
    disablePadding: false,
    label: "SATUAN BELI",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "satuan_jual",
    disablePadding: false,
    label: "SATUAN JUAL",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "hargapokok",
    disablePadding: false,
    label: "HPP",
    align: "center",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "hargabeli",
    disablePadding: false,
    label: "HARGA BELI",
    align: "center",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "qty_total",
    disablePadding: false,
    label: "PERSEDIAAN",
    align: "left",
    sort: false,
    minWidth: "100px",
  },
  {
    id: "qjb",
    disablePadding: false,
    label: "QJB",
    align: "left",
  },
  {
    id: "namaProdusen",
    disablePadding: false,
    label: "PRODUSEN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "nama_golongan_barang",
    disablePadding: false,
    label: "GOLONGAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const SelectOptionDataMasterBarang = () => {
  const produsen = useSelectOption(
    true,
    urlGetProdusen,
    TYPE_INSTANCE4,
    "id",
    "name",
    "body",
  )
  const kelasTerapi = useSelectOption(
    true,
    urlGetKelasTerapi,
    TYPE_INSTANCE4,
    "id",
    "name",
    "data",
  )

  const golonganObat = useSelectOption(
    false,
    urlGetGolonganObat,
    TYPE_INSTANCE4,
    "id",
    "name",
    "data",
  )
  const jenisObat = useSelectOption(
    false,
    urlGetJenisObat,
    TYPE_INSTANCE4,
    "id",
    "name",
    "data",
  )

  const asuransi = useSelectOption(
    false,
    "/insurance/listinsurance_msb",
    TYPE_INSTANCE2,
  )

  const formula = useSelectOption(
    true,
    urlGetFormula,
    TYPE_INSTANCE4,
    "id",
    "name",
    "data",
  )

  const satuan = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterSatuan.get,
    TYPE_INSTANCE4,
  )

  const jenisHarga = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterHarga.get,
    TYPE_INSTANCE4,
    "id",
    "name",
    "data",
  )

  return {
    produsen,
    formula,
    asuransi,
    jenisObat,
    golonganObat,
    kelasTerapi,
    satuan,
    jenisHarga,
  }
}

export const status_barang = [
  {
    value: 2,
    label: "Semua",
  },
  {
    value: 1,
    label: "Aktif",
  },
  {
    value: 0,
    label: "Tidak Aktif",
  },
]
